import React from 'react';
import {useNavigate} from "react-router-dom";

const Modal = ({children, image, title}) => {
    const navigate = useNavigate();
    return (
        <div style={{
            backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,1) 22%, rgba(108,234,255,1) 85%)',
            boxShadow: '0px 0px 15px 14px rgba(0,0,0,0.23)',
            padding: '20px',
            borderRadius: '12px',
            marginTop: '50px',
            marginBottom: '50px',
            // overflow: 'scroll',
            position: 'absolute',
            bottom: '0px',
            left: 'calc((100% - 90vw) / 2)',
            right: 'calc((100% - 90vw) / 2)',
            top: '0px',
            zIndex: '20',
        }}>
            <div style={{
                backgroundColor: '#e4195f',
                cursor: 'pointer',
                position: 'absolute',
                top: '4px',
                right: '4px',
                width: '24px',
                height: '24px',
                borderRadius: '12px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <div style={{
                    color: '#FFF',
                    fontWeight: 'bold',
                }} onClick={() => navigate(-1)}>X
                </div>
            </div>
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr 1fr',
                gridTemplateRows: 'auto auto',
                position: 'absolute',
                // overflow: 'scroll',
                bottom: '20px',
                left: '20px',
                right: '20px',
                top: '20px',
                paddingRight: '30px',
            }}>
                <div style={{
                    backgroundColor: 'white',
                    gridColumn: "1 / -1",
                    position: "sticky",
                    top: 0,
                    height: '80px',
                }}>
                    <h1>{title}</h1>
                </div>
                <div style={{
                    overflowY: 'scroll',
                    scrollbarColor: 'orange',
                    gridColumn: '1 / span 3',
                    paddingRight: '5%',
                    paddingBottom: '20%',

                }}>
                    {children}
                </div>
                <div style={{
                    gridColumn: '4 / span 1',
                }}>
                    <img src={image}
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            position: 'sticky',
                            top: '80px',
                        }}/>
                </div>
            </div>

        </div>
    );
}

export default Modal;
